<template>
  <v-dialog 
    max-width="400"
    :value="isOpenDeleteConfirmModal"
    @click:outside="isCloseDeleteConfirmModal"
  >
    <v-card class="mx-auto mt-5">
      <v-card-title>
        <div>このトピックを削除しますか？</div>
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="isCloseDeleteConfirmModal" outlined color="gray">閉じる</v-btn>
        <v-btn @click="deleteTopic" outlined color="red">削除する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    name: 'DeleteConfirmModal',
    data() {
      return {
      }
    },
    props: [
      "isOpenDeleteConfirmModal",
      "isCloseDeleteConfirmModal",
      "topic_id",
    ],
    computed: {
      getUserCode: function() {
        return this.$store.getters['auth/isUserCode']
      },
    },
    methods: {
      deleteTopic() {
        this.$store.dispatch('topic/delete', this.topic_id)
          .then(() => {
            this.$router.push('/user/' + this.getUserCode)
          })
      },
    },
  }
</script>
